export default __webpack_public_path__ + "img/cHMxNHBF.c476dff1.svg";